import { render } from "./preabout.vue?vue&type=template&id=aafc1f7c&ts=true"
import script from "./preabout.vue?vue&type=script&lang=ts"
export * from "./preabout.vue?vue&type=script&lang=ts"

import "./preabout.vue?vue&type=style&index=0&id=aafc1f7c&lang=scss"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__